import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TieListPage } from './tie-list.page';

const routes: Routes = [
    {
        path: '',
        component: TieListPage,
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class TiesListPageRoutingModule { }
